import { Link } from "react-router";
import { LoginForm } from "./login.components/login-form.tsx";

export default function Login() {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-center gap-2 md:justify-start">
          <Link to="/" className="flex items-center gap-2 font-medium">
            <img src="/logo.png" alt="Image" className="inset-0 h-9 dark:brightness-[0.2] dark:grayscale dark:invert" />
          </Link>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs">
            <LoginForm />
          </div>
        </div>
      </div>
      <div className="hidden bg-white md:flex dark:bg-black items-center justify-center">
        <img
          src="/login.png"
          alt="Image"
          className="h-[70%] w-[70%] object-cover dark:brightness-[0.2] dark:grayscale dark:invert"
        />
      </div>
    </div>
  );
}
